import { listMaterialDropdown } from "../../../../api/actions/material";

let typingTimerMaterial;

export const materialLoadOptionHandler = (
  inputValue,
  userData,
  setMaterial
) => {
  return new Promise((resolve, reject) => {
    clearTimeout(typingTimerMaterial);
    typingTimerMaterial = setTimeout(() => {
      if (inputValue.length >= 1) {
        listMaterialDropdown({
          page: 1,
          search: inputValue,
          museum_id: userData?.museum,
        })((response) => {
          if (response?.status) {
            setMaterial(response?.data);
            resolve(response?.data);
          }
        });
      } else {
        resolve([]);
      }
    }, 300);
  });
};
